var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"photos-view"},[_c('div',{staticClass:"btn",on:{"click":_vm.attachAll}},[_vm._v("Vedhæft alle")]),_c('div',{staticClass:"container"},_vm._l((_vm._items),function(p,i){return _c('div',{key:i,staticClass:"thumb",style:({
			backgroundImage: 'url(' + p.url + ')'
		}),on:{"click":function($event){return _vm.open(p.url)}}},[_c('div',{staticClass:"attach",on:{"click":function($event){$event.stopPropagation();return _vm.attach(p)}}},[_vm._v("Vedhæft")])])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }